import * as actionTypes from './actionTypes';
export const clearOrganization = ()=>({
        type: actionTypes.CLEAR_ORGANIZATION
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchOrganizationMemberships = (organization)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS,
        payload: {
            organization
        }
    });
export const fetchOrganizationMembershipsSuccess = (organizationMemberships)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS,
        payload: {
            organizationMemberships
        }
    });
export const fetchOrganizationMembershipsError = (error)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const approveMembership = (organizationMembership, adminOrganizationMembership)=>({
        type: actionTypes.APPROVE_MEMBERSHIP,
        payload: {
            organizationMembership,
            adminOrganizationMembership
        }
    });
export const approveMembershipSuccess = (organizationMembership)=>({
        type: actionTypes.APPROVE_MEMBERSHIP_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const approveMembershipError = (error)=>({
        type: actionTypes.APPROVE_MEMBERSHIP_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const rejectMembership = (organizationMembership, adminOrganizationMembership)=>({
        type: actionTypes.REJECT_MEMBERSHIP,
        payload: {
            organizationMembership,
            adminOrganizationMembership
        }
    });
export const rejectMembershipSuccess = (organizationMembership)=>({
        type: actionTypes.REJECT_MEMBERSHIP_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const rejectMembershipError = (error)=>({
        type: actionTypes.REJECT_MEMBERSHIP_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const deleteMembership = (organizationMembership, adminOrganizationMembership)=>({
        type: actionTypes.DELETE_MEMBERSHIP,
        payload: {
            organizationMembership,
            adminOrganizationMembership
        }
    });
export const deleteMembershipSuccess = (organizationMembership)=>({
        type: actionTypes.DELETE_MEMBERSHIP_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const deleteMembershipError = (error)=>({
        type: actionTypes.DELETE_MEMBERSHIP_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const createInvitation = (values, adminOrganizationMembership)=>({
        type: actionTypes.CREATE_INVITATION,
        payload: {
            values,
            adminOrganizationMembership
        }
    });
export const createInvitationSuccess = ()=>({
        type: actionTypes.CREATE_INVITATION_SUCCESS
    });
export const createInvitationError = (error)=>({
        type: actionTypes.CREATE_INVITATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const cancelInvitation = (organizationMembership, adminOrganizationMembership)=>({
        type: actionTypes.CANCEL_INVITATION,
        payload: {
            organizationMembership,
            adminOrganizationMembership
        }
    });
export const cancelInvitationSuccess = (organizationMembership)=>({
        type: actionTypes.CANCEL_INVITATION_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const cancelInvitationError = (error)=>({
        type: actionTypes.CANCEL_INVITATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const resendInvitation = (organizationMembership, adminOrganizationMembership)=>({
        type: actionTypes.RESEND_INVITATION,
        payload: {
            organizationMembership,
            adminOrganizationMembership
        }
    });
export const resendInvitationSuccess = (organizationMembership)=>({
        type: actionTypes.RESEND_INVITATION_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const resendInvitationError = (error)=>({
        type: actionTypes.RESEND_INVITATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const grantAdmin = (organizationMembership)=>({
        type: actionTypes.GRANT_ADMIN,
        payload: {
            organizationMembership
        }
    });
export const grantAdminSuccess = (organizationMembership)=>({
        type: actionTypes.GRANT_ADMIN_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const grantAdminError = (error)=>({
        type: actionTypes.GRANT_ADMIN_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const revokeAdmin = (organizationMembership)=>({
        type: actionTypes.REVOKE_ADMIN,
        payload: {
            organizationMembership
        }
    });
export const revokeAdminSuccess = (organizationMembership)=>({
        type: actionTypes.REVOKE_ADMIN_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const revokeAdminError = (error)=>({
        type: actionTypes.REVOKE_ADMIN_ERROR,
        error
    }); //----------------------------------------------------------------------------------------------------------------------
